'use strict';

var ticky = require('ticky');

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/contra/debounce.js
// module id = 1037
// module chunks = 0